import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import { BaseService } from "../base.service";

@Component({
  selector: "app-cast-crew-list",
  templateUrl: "./cast-crew-list.component.html",
  styleUrls: ["./cast-crew-list.component.css"],
})
export class CastCrewListComponent implements OnInit {
  reletedShows: any = [];
  app_constant: any;
  shimarStatus = true;
  favoriteData = [];
  apiParam = { name: "", limit: 10, offset: 0 };
  loadMore: boolean;
  initStatus: boolean;
  constructor(private service: BaseService, private route: ActivatedRoute) { }
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.loadMore = true;
    this.shimarStatus = true;
    this.app_constant = environment;

    this.route.queryParams.subscribe((params) => {
      this.apiParam.name = params["name"];
      this.service.castCrewList(this.apiParam).subscribe(
        (res) => {
          if (res) {
            this.reletedShows = res.results;
            this.shimarStatus = false;
            this.loadMore = false;
          }
        },
        (err: any) => {
          this.shimarStatus = false;
          this.loadMore = false;
        }
      );
    });
  }
}
